import { featureFlagIsActive } from "./featureFlag"

export function recordInteractionIfAffiliatePage(): void {
    if (!featureFlagIsActive("AffPromoCookieOnClick") || window.affiliateInteractionCallback === undefined) {
        return
    }
    window.affiliateInteractionCallback()
}
